import { Actions, ButtonLink, IconRenderer } from 'braid-design-system';

import file from './UnitTestCases.xlsx';
import { MicrosoftExcelLogoIcon } from '@phosphor-icons/react';

export const UnitTestCases = () => (
  <Actions>
    <ButtonLink
      download="2025 Apply with SEEK revision - Unit Test Cases.xlsx"
      href={file}
      icon={
        <IconRenderer>
          {({ className }) => <MicrosoftExcelLogoIcon className={className} />}
        </IconRenderer>
      }
      variant="soft"
    >
      Unit Test Cases
    </ButtonLink>
  </Actions>
);
